module.exports = __webpack_public_path__ + "static/media/logoWhatsapp.507654d9.png";